'use client';

import OurVision from '@/assets/images/convention/craftsmanship/AW-OurVision.svg';
import Service from '@/assets/images/convention/craftsmanship/AW-Service.svg';
import Workmanship from '@/assets/images/convention/craftsmanship/AW-Workmanship&Quality.svg';
import Craftsmanshipbanner from '@/assets/images/convention/craftsmanship/Craftsmanshipbanner.jpg';
import Image from 'next/image';
import classes from './craftsmanship.module.css';

export const Craftsmanship = () => {
  return (
    <>
      <div className={classes.craftsmanship}>
        <h1 className={classes.title}>CRAFTSMANSHIP</h1>
        <div className={classes.conent}>
          <div className={classes.introduce}>
            <Image
              className={classes.introduceimg}
              src={OurVision}
              alt=''
            />
            <h4 className={classes.introducetitle}>Our Vision</h4>
            <span className={classes.introducecon}>
              A wedding is about happiness, bliss, and the promise to grow old together. AW.Bridal is here to provide
              everything you need for these cherished moments.
            </span>
          </div>
          <div className={classes.introduce}>
            <Image
              className={classes.introduceimg}
              src={Workmanship}
              alt=''
            />
            <h4 className={classes.introducetitle}>Workmanship & Quality</h4>
            <span className={classes.introducecon}>
              At AW.Bridal, we pride ourselves on exceptional craftsmanship and superior quality. Our team of designers
              and tailors pays close attention to detail in every piece, ensuring that all hand-sewn trim, beadwork, and
              embroidery meet our high standards. We are dedicated to providing products that are both high-quality and
              versatile, helping to make your special moments truly unforgettable.
            </span>
          </div>
          <div className={classes.introduce}>
            <Image
              className={classes.introduceimg}
              src={Service}
              alt=''
            />
            <h4 className={classes.introducetitle}>Service</h4>
            <span className={classes.introducecon}>
              AW.Bridal champions unparalleled customer service and offers logistics services in many countries,
              ensuring fast shipping for all orders. If you have any questions, please contact us via email, phone, or
              online customer care service. We are here to help!
            </span>
          </div>
        </div>
        <Image
          className={classes.footerimg}
          src={Craftsmanshipbanner}
          alt=''
        />
      </div>
    </>
  );
};

export default Craftsmanship;
